import React, { useRef, useState, useEffect } from "react";
import Card from "../Card/Card";
import { useNavigate } from "react-router-dom";
import { normalizarTipo, projetoEhDoTipo } from "../../utils/projetos";


function SecaoAutomatica({ titulo, tag, projetos, id, handleCardClick, ativa }) {

  const navigate = useNavigate();
  const onCardClick = handleCardClick || ((id) => navigate(`/projeto/${id}`));

  const tipoSecao = normalizarTipo(tag);
  const projetosFiltrados = projetos.filter((p) => projetoEhDoTipo(p, tipoSecao));
  const scrollRef = useRef(null);

  const [podeIrEsquerda, setPodeIrEsquerda] = useState(false);
  const [podeIrDireita, setPodeIrDireita] = useState(true);

  function verificarScroll() {
    const container = scrollRef.current;

    if (!container) return;

    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;

    setPodeIrEsquerda(scrollLeft > 0);
    setPodeIrDireita(scrollLeft + clientWidth < scrollWidth - 1);
  }

  useEffect(function () {

    const container = scrollRef.current;

    if (!container) return;

    function atualizar() {
      verificarScroll();
    }

    verificarScroll();

    container.addEventListener("scroll", atualizar);
    window.addEventListener("resize", atualizar);

    return function () {
      container.removeEventListener("scroll", atualizar);
      window.removeEventListener("resize", atualizar);
    };

  }, [projetosFiltrados]);


  if (projetosFiltrados.length === 0) return null;

  // 🔹 Funções para mover o carrossel
  function scrollLeft() {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  }

  function scrollRight() {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  }

  // 🔹 Função para abrir a página da categoria
  function irParaCategoria() {
    const tipo = normalizarTipo(tag);

    if (tipo === "RV") navigate("/rv");
    if (tipo === "RA") navigate("/ra");
    if (tipo === "Video 360") navigate("/video360");
    if (tipo === "Video 360i") navigate("/video360i");
  }

  return (
    <section className={`secao-automatica ${ativa ? "ativa" : "inativa"}`} id={id}>
      <div className="secao-cabecalho">
        <h2>{titulo}</h2>
      </div>

      <div className="carousel-wrapper">
        {podeIrEsquerda && (
          <button className="carousel-btn left" onClick={scrollLeft}>
            ❮
          </button>
        )}

        <div className="cards-container" ref={scrollRef}>
          {projetosFiltrados.map((projeto) => (
            <Card key={projeto.id} projeto={projeto} onClick={onCardClick} />
          ))}
        </div>

        {podeIrDireita && (
          <button className="carousel-btn right" onClick={scrollRight}>
            ❯
          </button>
        )}
      </div>
      <button className="btn-ver-todos" onClick={irParaCategoria}>
        Ver todos
      </button>
    </section>
  );
}

export default SecaoAutomatica;
